module.exports = __webpack_public_path__ + "static/img/1.defe014.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/1.png
// module id = a5rq
// module chunks = 0